import {environment} from '../../../../apps/frontend/src/environments/environment'
import {Injectable} from '@angular/core'
import {HttpClient} from '@angular/common/http'
import {map, Observable} from 'rxjs'
import {ConfigModel, ConfigName, DescriptionModel} from '../../../domain/src/lib/config.model'


@Injectable({
  providedIn: 'root',
})
export class ConfigService {

  constructor(private readonly http: HttpClient) {
  }


  getConfigs(): Observable<ConfigModel[]> {
    const url = `${environment.apiUrl}/configs`
    return this.http.get<ConfigModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  /*
   getConfigByName(configName: ConfigName): Observable<ConfigModel> {
   const configs=this.getConfigsByNames([configName])
   return configs[0]
   const url = `${environment.apiUrl}/configs/names/${configName}`
   return this.http.get<ConfigModel[]>(url).pipe(
   map(values => {
   return values[0]
   }),
   */


  getConfigsByNames(configNames: ConfigName[]): Observable<ConfigModel[]> {
    const url = `${environment.apiUrl}/configs/names/${configNames}`
    return this.http.get<ConfigModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getDescriptions(groupId?: number): Observable<DescriptionModel[]> {
    let url = `${environment.apiUrl}/configs/descriptions`
    if (groupId) {
      url = `${url}?groupId=${groupId}`
    }
    return this.http.get<DescriptionModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }
}
